export const UPDATE_AUTO_ROTATE = 'UPDATE_AUTO_ROTATE'
export const UPDATE_CALLOUTS_VISIBILITY = 'UPDATE_CALLOUTS_VISIBILITY'
export const UPDATE_EXPLODED_MODE = 'UPDATE_EXPLODED_MODE'
export const UPDATE_BUTTONS_CONFIG = 'UPDATE_BUTTONS_CONFIG'
export const UPDATE_RESET_CAMERA = 'UPDATE_RESET_CAMERA'

export const updateAutoRotate = (
  payload: boolean
): {
  type: typeof UPDATE_AUTO_ROTATE
  payload: boolean
} => ({
  type: UPDATE_AUTO_ROTATE,
  payload
})

export const updateCalloutsVisibility = (
  payload: boolean
): {
  type: typeof UPDATE_CALLOUTS_VISIBILITY
  payload: boolean
} => ({
  type: UPDATE_CALLOUTS_VISIBILITY,
  payload
})

export const updateExplodedMode = (
  payload: boolean
): {
  type: typeof UPDATE_EXPLODED_MODE
  payload: boolean
} => ({
  type: UPDATE_EXPLODED_MODE,
  payload
})

export const updateResetCamera = (
  payload: boolean
): {
  type: typeof UPDATE_RESET_CAMERA
  payload: boolean
} => ({
  type: UPDATE_RESET_CAMERA,
  payload
})

type updateButtonsConfigPayload = {
  autoRotate: {
    enabled: boolean
  }
  exploded: {
    enabled: boolean
  }
  callouts: {
    enabled: boolean
  }
  resetCamera: {
    enabled: boolean
  }
}

export const updateButtonsConfig = (
  payload: updateButtonsConfigPayload
): {
  type: typeof UPDATE_BUTTONS_CONFIG
  payload: updateButtonsConfigPayload
} => ({
  type: UPDATE_BUTTONS_CONFIG,
  payload
})

export type UpdateThreeDAction
  = | ReturnType<typeof updateAutoRotate>
  | ReturnType<typeof updateCalloutsVisibility>
  | ReturnType<typeof updateExplodedMode>
  | ReturnType<typeof updateButtonsConfig>
  | ReturnType<typeof updateResetCamera>
